<template>
  <div class="station-file-body">
    <left-tree
      :tabValue="tabValue"
      :selectedKeys="selectedKeys"
      @selectTree="selectTree"
      @selectedInfo="selectedInfo"
    >
    </left-tree>
    <right-tabs
      :tabValue="tabValue"
      :treeInfo="treeInfo"
      :selectedKeys="selectedKeys"
      @changeTab="(value) => changeTab(value)"
    >
    </right-tabs>
  </div>
</template>

<script>
import LeftTree from './components/LeftTree.vue'
import RightTabs from './components/RightTabs.vue'
export default {
  components: {
    LeftTree,
    RightTabs
  },
  data() {
    return {
      tabValue: '1',
      selectedKeys: [],
      treeInfo: {}
    }
  },
  methods: {
    changeTab(value) {
      this.tabValue = value
    },
    selectTree(selectedKeys) {
      this.selectedKeys = selectedKeys
    },
    selectedInfo(value) {
      this.treeInfo = value
    }
  }
}
</script>

<style lang="less" scoped>
.station-file-body {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
